const { REACT_APP_ASSETS_URL } = process.env;
export default {
  siteName: 'J5Ismoyo',
  footerText: `Copyright Toko Emas J5Ismoyo @2019`,
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1'
  },
  dashboard: '/dashboard',
  assets: {
    'member/upload': `${REACT_APP_ASSETS_URL}/member`,
    'promo/upload': `${REACT_APP_ASSETS_URL}/promo`,
    'voucher/upload': `${REACT_APP_ASSETS_URL}/voucher`,
    'product/upload': `${REACT_APP_ASSETS_URL}/product`,
    'order-bengkel/upload': `${REACT_APP_ASSETS_URL}/bengkel`
  }
};
